import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import React from "react";

const NotificationTemplateSchema = Yup.object().shape({
    titleEn: Yup.string()
        .max(100, "Title must be 100 characters or less"),
    bodyEn: Yup.string()
        .required("English body is required")
        .max(500, "Body must be 500 characters or less"),
    titleNl: Yup.string()
        .max(100, "Title must be 100 characters or less"),
    bodyNl: Yup.string()
        .required("Dutch body is required")
        .max(500, "Body must be 500 characters or less"),
});

const NotificationTemplateForm = ({ initialValues, onSubmit, isEditing = false }) => {
    return (
        <Formik
            initialValues={{
                titleEn: "",
                bodyEn: "",
                titleNl: "",
                bodyNl: "",
                ...initialValues,
            }}
            validationSchema={NotificationTemplateSchema}
            onSubmit={async (values, actions) => {
                try {
                    await onSubmit(values);
                } catch (error) {
                    console.error(error);
                } finally {
                    actions.setSubmitting(false);
                }
            }}
        >
            {({ isSubmitting }) => (
                <Form className="card p-4 shadow rounded">
                    <div className="form-group mb-3">
                        <label>Title (English)</label>
                        <Field
                            name="titleEn"
                            type="text"
                            className="form-control"
                        />
                        <ErrorMessage
                            name="titleEn"
                            component="div"
                            className="text-danger"
                        />
                    </div>

                    <div className="form-group mb-3">
                        <label>Body (English)</label>
                        <Field
                            name="bodyEn"
                            as="textarea"
                            rows={4}
                            className="form-control"
                        />
                        <ErrorMessage
                            name="bodyEn"
                            component="div"
                            className="text-danger"
                        />
                    </div>

                    <div className="form-group mb-3">
                        <label>Title (Nederlands)</label>
                        <Field
                            name="titleNl"
                            type="text"
                            className="form-control"
                        />
                        <ErrorMessage
                            name="titleNl"
                            component="div"
                            className="text-danger"
                        />
                    </div>

                    <div className="form-group mb-3">
                        <label>Body (Nederlands)</label>
                        <Field
                            name="bodyNl"
                            as="textarea"
                            rows={4}
                            className="form-control"
                        />
                        <ErrorMessage
                            name="bodyNl"
                            component="div"
                            className="text-danger"
                        />
                    </div>

                    <div className="text-end toolbar toolbar-bottom p-2">
                        <button
                            className="btn btn-secondary sw-btn-next ms-1"
                            type="submit"
                            disabled={isSubmitting}
                        >
                            Update Template
                        </button>
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default NotificationTemplateForm;
